export const wheels = ({ wheels }) => wheels.byId;
